import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmt } from "@/lib/api";
import { Empty } from "@/components/ui-bits";

const describe = (r) => Object.entries(r || {}).map(([k, v]) => `${k}: ${v}`).join(" · ");

export default function Automations() {
  const [d, setD] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [newQuote, setNewQuote] = useState("");
  const [busy, setBusy] = useState("");
  const load = useCallback(() => Promise.all([api.get("/automations"), api.get("/motivation/templates")]).then(([a, t]) => { setD(a.data); setTemplates(t.data); }), []);
  useEffect(() => { load(); }, [load]);

  const run = async (job) => {
    setBusy(job);
    try { const r = await api.post(`/automations/${job}/run`); toast.success(`${job} done — ${describe(r.data.result)}`); load(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  const addQuote = async (e) => {
    e.preventDefault();
    try { await api.post("/motivation/templates", { body: newQuote }); setNewQuote(""); toast.success("Quote added"); load(); } catch (ex) { toast.error(errMsg(ex)); }
  };
  const toggle = async (t) => { await api.patch(`/motivation/templates/${t.id}`, { active: !t.active }); load(); };
  const remove = async (t) => { await api.delete(`/motivation/templates/${t.id}`); load(); };

  if (!d) return <div className="center"><span className="spin" /></div>;
  return (
    <div className="fade" data-testid="admin-automations">
      <div className="grid2">
        <div className="panel">
          <h3>Scheduled jobs · run on the platform cron (Asia/Singapore) — or trigger now</h3>
          {d.jobs.map((j) => (
            <div className="sess" key={j.job} data-testid={`job-${j.job}`}>
              <div className="t" style={{ width: 110 }}>{j.schedule}</div>
              <div className="sb">
                <div className="st">{j.label}</div>
                <div className="ss">{j.desc}</div>
                <div className="ss" style={{ marginTop: 2 }}>{j.lastRun ? `Last run ${fmt(j.lastRun.ranAt, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })} (${j.lastRun.trigger}) — ${describe(j.lastRun.result)}` : "Never run"}</div>
              </div>
              <button className="btn sm" disabled={!!busy} onClick={() => run(j.job)} data-testid={`run-${j.job}`}>{busy === j.job ? "Running…" : "Run now"}</button>
            </div>
          ))}
        </div>
        <div>
          <div className="panel">
            <h3>Motivation quotes · rotate daily, {"{firstName}"} is replaced</h3>
            {templates.length === 0 && <Empty>No quotes.</Empty>}
            {templates.map((t) => (
              <div className="sess" key={t.id} style={{ opacity: t.active ? 1 : 0.5 }} data-testid={`quote-${t.id}`}>
                <div className="sb"><div className="ss" style={{ color: "var(--ink)" }}>{t.body}</div></div>
                <button className="btn sm g" onClick={() => toggle(t)} data-testid={`quote-toggle-${t.id}`}>{t.active ? "Pause" : "Enable"}</button>
                <button className="btn sm danger" onClick={() => remove(t)} data-testid={`quote-delete-${t.id}`}>Delete</button>
              </div>
            ))}
            <form onSubmit={addQuote} style={{ display: "flex", gap: 8, marginTop: 12 }}>
              <input required placeholder="New quote… use {firstName}" value={newQuote} onChange={(e) => setNewQuote(e.target.value)} data-testid="quote-input" />
              <button className="btn sm" data-testid="quote-add-button">Add</button>
            </form>
          </div>
          <div className="panel">
            <h3>Recent runs</h3>
            {d.recentRuns.length === 0 && <Empty>No runs yet.</Empty>}
            <table className="tbl">
              <tbody>
                {d.recentRuns.slice(0, 12).map((r) => (
                  <tr key={r.id} data-testid={`run-row-${r.id}`}><td className="num" style={{ whiteSpace: "nowrap" }}>{fmt(r.ranAt, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</td><td><b>{r.job}</b> <span className="ss">({r.trigger})</span></td><td className="ss">{describe(r.result)}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
